/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/

/*
  In this file, we configure the menus name with URL
*/
/* istanbul ignore file */

// System defined variables
import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom' //useNavigate
//import { StyledEngineProvider } from '@mui/material/styles'
import Collapse from '@mui/material/Collapse'
import {
  Drawer as MUIDrawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  ListItemButton,
} from '@mui/material' //IconButton,
import {
  useRecoilValue,
  useSetRecoilState,
  useRecoilState,
  useResetRecoilState,
} from 'recoil'
import { useConfirm } from 'material-ui-confirm'
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight'
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft'
import _ from 'lodash'

// Custom defined variables.
import './MenuLayout.css'
import {
  selectedContractDetails,
  selectedMenuData,
  madeChanges,
  selectOrgNavigationDetails,
  mappedUserRoles,
  selectLinkedCaseDetails, //selectLinkedCaseDetails-> this atom wll not used in future as we going to use queryParams for case id -> linked case will also follow browser history.
  searchListFormGridData,
  isSidebarExpanded,
  reportFavouriteData,
  toastMessage,
  lastSelectedTab,
  assignedDistinctRoles,
  caseOverviewTabSelectedIndexAtom,
  airaLayoutChanges,
  selectedCaseDetails,
  jobTabIndex,
  poundTabIndex,
  menuItemDatasourceAtom,
  reportFavouritesRefreshStatusAtom,
  reportConfigurationData,
  widgetState,
  boManagerLocationZoneEnabled,
  boManagerBriefingAccessEnabled,
  caseOverviewDataAtom,
  refreshCaseOverview,
  myWorkflowSummarizationDialog,
  onHoldSummarizationDialog,
  pcnPageSummarizationDialog,
  caseNumber,
  assignedContractRoles,
} from '../../recoil/atoms/atoms'
import { fetchDataSelector } from '../../recoil/selectors/selectors'
import utils from '../../../../utils/utils'
import { isScotlandPcnContractType } from '../../../pages/contract/constants/staticCode'
import { ConfirmPopupRendererObject } from '../confirmPopupRenderer/ConfirmPopupRenderer'
import APIEndPoints from '../../../../models/api/apiEndpoints'
import HaloSupportTicket from '../../../pages/home/HaloSupportTicket'
import SupportMenuIconInActive from '../../../../assets/images/supportMenuIcon.svg'
import SupportMenuIconActive from '../../../../assets/images/supportMenuIconActive.svg'

// ref,props = {}
function MenuLayout() {
  const navigate = useNavigate()
  const confirmAlert = useConfirm()
  const getCoreData = useRecoilValue(fetchDataSelector)
  const selectedContractData = useRecoilValue(selectedContractDetails)
  const userRolesData = useRecoilValue(mappedUserRoles)
  const setMappedUserRolesData = useSetRecoilState(mappedUserRoles)
  const assignedContractRolesData = useRecoilValue(assignedContractRoles)
  const isAiraLayoutChanges = useRecoilValue(airaLayoutChanges)
  const resetLastSelectedTab = useResetRecoilState(lastSelectedTab)
  const resetCaseOverviewTabSelectedIndex = useResetRecoilState(
    caseOverviewTabSelectedIndexAtom
  )
  const setJobIndex = useSetRecoilState(jobTabIndex)
  const setPoundIndex = useSetRecoilState(poundTabIndex)
  const [selectLinkedCaseDetailsData, setSelectLinkedCaseDetails] =
    useRecoilState(selectLinkedCaseDetails)
  const [selectSearchListFormGridData, setSearchListFormGridData] =
    useRecoilState(searchListFormGridData)
  const setSelectedcaseDetails = useSetRecoilState(selectedCaseDetails)
  const [selectedMenuDataValue, setSelectedMenuData] =
    useRecoilState(selectedMenuData)

  const [isMenuBarExpanded, setMenuBarExpanded] =
    useRecoilState(isSidebarExpanded)
  const [supportMenuSelected, setSupportMenuSelected] = useState(false)

  const [menuItemDatasource, setMenuItemDatasource] = useRecoilState(
    menuItemDatasourceAtom
  )
  const [reportFavouritesRefreshStatus, setReportFavouritesRefreshStatus] =
    useRecoilState(reportFavouritesRefreshStatusAtom)
  const setReportFavouriteData = useSetRecoilState(reportFavouriteData)
  const hasChanges = useRecoilValue(madeChanges)
  const showToastMessage = useSetRecoilState(toastMessage)
  const widgetTypeValue = useRecoilValue(widgetState)
  const [selectNavigationDetails, setSelectNavigationDetails] = useRecoilState(
    selectOrgNavigationDetails
  )
  const [reportConfiguredData, setReportConfiguredData] = useRecoilState(
    reportConfigurationData
  )
  const [reportDetails, setReportDetails] = useState([])
  const resetMyWorkflowSummarizationDialog = useResetRecoilState(
    myWorkflowSummarizationDialog
  )
  const resetOnHoldSummarizationDialog = useResetRecoilState(
    onHoldSummarizationDialog
  )
  const resetPcnPageSummarizationDialog = useResetRecoilState(
    pcnPageSummarizationDialog
  )
  const resetCaseNumber = useResetRecoilState(caseNumber)
  const [openCollapse, setOpenCollapseSubmenu] = React.useState({
    firstLevelMenu: '',
    secondLevelMenu: '',
  })
  const caseOverviewData = useRecoilValue(caseOverviewDataAtom)
  const setCaseOverviewData = useSetRecoilState(caseOverviewDataAtom)
  const resetCaseOverviewData = useResetRecoilState(caseOverviewDataAtom)
  const menuEnableCheck = caseOverviewData?.isPreDebtCleanse || false
  const [lastClickedMenu, setLastClickedMenu] = useState({
    firstLevelMenu: '',
    secondLevelMenu: '',
    thirdLevelMenu: '',
  })
  const isOrgWidget = widgetTypeValue?.type === utils?.widgetTypes?.organisation

  const MENU_KEYS = ['configuration', 'zone', 'location']
  const BRIEFING_MENU_KEY = 'briefing'
  const roleName = 'BOManager'
  const setBoManagerLocationZoneValue = useSetRecoilState(
    boManagerLocationZoneEnabled
  )
  const setBoManagerBriefingAccessValue = useSetRecoilState(
    boManagerBriefingAccessEnabled
  )
  const boManagerBriefingAccessValue = useRecoilValue(
    boManagerBriefingAccessEnabled
  )
  const refreshInvalidator = useRecoilValue(refreshCaseOverview)
  const isInitialRefreshInvalidator = React.useRef(true)
  // Helper function to update the menu datasource.
  // Adds or removes the "BOManager" role from the relevant menu sections dynamically. Since the utils file uses the same role (menuAccessRoles?.configuration) for all menus under Configuration, updating the utils with a flag or adding "BOManager" directly would cause the menu to display incorrectly, and even allow access to unauthorized pages via direct URL. That’s why we update the role dynamically in MenuLayout.js
  useEffect(() => {
    const updateMenuRoles = (enable) => {
      setMenuItemDatasource((prev) => {
        if (!prev) return prev
        const newDatasource = { ...prev }
        MENU_KEYS.forEach((key) => {
          const menu = newDatasource[key]
          if (!menu || !Array.isArray(menu?.roles)) return
          const hasRole = menu?.roles?.includes(roleName)
          if (enable && !hasRole) {
            newDatasource[key] = {
              ...menu,
              roles: [...menu?.roles, roleName],
            }
          } else if (!enable && hasRole) {
            newDatasource[key] = {
              ...menu,
              roles: menu?.roles?.filter((r) => r !== roleName),
            }
          }
        })
        return newDatasource
      })
    }
    const fetchAndApply = async () => {
      if (!userRolesData?.includes(roleName)) return
      try {
        const { method, url } =
          APIEndPoints?.getBoManagerLocationZoneValue ?? {}
        const response = await getCoreData(method, url)
        if (response?.status === utils?.apiResponseCode?.successCode) {
          // Store the entire API response object in the Recoil atom.
          const responseData = response?.data || {
            isBOManagerLocationZoneEnabled: false,
            contractData: [],
          }
          setBoManagerLocationZoneValue(responseData)
          updateMenuRoles(responseData?.isBOManagerLocationZoneEnabled)
        } else if (response?.data?.message) {
          showToastMessage({
            message: response?.data?.message,
            status: utils?.toastStatus?.error,
          })
        }
      } catch (error) {
        showToastMessage({
          message: error?.message || String(error),
          status: utils?.toastStatus?.error,
        })
        setBoManagerLocationZoneValue({
          isBOManagerLocationZoneEnabled: false,
          contractData: [],
        })
        updateMenuRoles(false)
      }
    }
    fetchAndApply()
  }, [userRolesData])

  // Update Briefing menu access for BOManager based on selected contract's toggle value
  useEffect(() => {
    const updateBriefingMenuRoles = (enable) => {
      setMenuItemDatasource((prev) => {
        if (!prev) return prev
        const newDatasource = { ...prev }
        const briefingMenu = newDatasource[BRIEFING_MENU_KEY]
        if (!briefingMenu || !Array.isArray(briefingMenu?.roles)) return prev
        const hasRole = briefingMenu?.roles?.includes(roleName)
        if (enable && !hasRole) {
          newDatasource[BRIEFING_MENU_KEY] = {
            ...briefingMenu,
            roles: [...briefingMenu?.roles, roleName],
          }
        } else if (!enable && hasRole) {
          newDatasource[BRIEFING_MENU_KEY] = {
            ...briefingMenu,
            roles: briefingMenu?.roles?.filter((r) => r !== roleName),
          }
        }
        return newDatasource
      })
    }

    if (!userRolesData?.includes(roleName)) {
      updateBriefingMenuRoles(false)
      setBoManagerBriefingAccessValue(false)
      return
    }

    const briefingAccessEnabled =
      !!selectedContractData?.isBOManagerBriefingMenuEnabled
    setBoManagerBriefingAccessValue(briefingAccessEnabled)
    updateBriefingMenuRoles(briefingAccessEnabled)
  }, [selectedContractData?.isBOManagerBriefingMenuEnabled, userRolesData])

  // Update bailiffOfContract menu display text based on contract type (Sheriff Officer for Scotland PCN)
  useEffect(() => {
    const isScotslandPcn = isScotlandPcnContractType(
      selectedContractData?.contractType
    )
    setMenuItemDatasource((prev) => {
      if (!prev?.bailiffOfContract) return prev
      return {
        ...prev,
        bailiffOfContract: {
          ...prev.bailiffOfContract,
          displayText: isScotslandPcn
            ? 'Sheriff Officer'
            : 'Enforcement Agency',
        },
      }
    })
  }, [selectedContractData?.contractType])

  // Auto-highlight the abandoned vehicles menu when an abandoned vehicle contract is selected
  useEffect(() => {
    if (
      selectedContractData?.contractType?.toString()?.toLowerCase() ===
      utils?.contractTypes?.abandonedVehicle
    ) {
      const menuKey = 'abandonedVehiclesForAbandonedVehicleContract'
      setLastClickedMenu({
        firstLevelMenu: menuKey,
        secondLevelMenu: '',
        thirdLevelMenu: '',
      })
      setSelectedMenuData({
        firstLevelMenu: menuKey,
        secondLevelMenu: '',
        thirdLevelMenu: '',
        projectType: null,
      })
    }
  }, [selectedContractData?.contractId])

  // capture user login activity on page refresh for privateLand contracts
  useEffect(() => {
    if (
      selectedContractData?.contractType?.toLowerCase() ===
      utils?.contractTypes?.privateLand
    ) {
      getCoreData(
        APIEndPoints?.captureUserActivity?.method,
        `${APIEndPoints?.captureUserActivity?.url}?contractId=${selectedContractData?.contractId}&isLogin=true`,
        null,
        null,
        null,
        true,
        utils?.apiDomainName?.privateLand?.name
      )
    }
  }, [])

  // Update Briefing menu access for BOManager based on selected contract's toggle value
  useEffect(() => {
    const updateBriefingMenuRoles = (enable) => {
      setMenuItemDatasource((prev) => {
        if (!prev) return prev
        const newDatasource = { ...prev }
        const briefingMenu = newDatasource[BRIEFING_MENU_KEY]
        if (!briefingMenu || !Array.isArray(briefingMenu?.roles)) return prev
        const hasRole = briefingMenu?.roles?.includes(roleName)
        if (enable && !hasRole) {
          newDatasource[BRIEFING_MENU_KEY] = {
            ...briefingMenu,
            roles: [...briefingMenu?.roles, roleName],
          }
        } else if (!enable && hasRole) {
          newDatasource[BRIEFING_MENU_KEY] = {
            ...briefingMenu,
            roles: briefingMenu?.roles?.filter((r) => r !== roleName),
          }
        }
        return newDatasource
      })
    }

    if (!userRolesData?.includes(roleName)) {
      updateBriefingMenuRoles(false)
      setBoManagerBriefingAccessValue(false)
      return
    }

    const briefingAccessEnabled =
      !!selectedContractData?.isBOManagerBriefingMenuEnabled
    setBoManagerBriefingAccessValue(briefingAccessEnabled)
    updateBriefingMenuRoles(briefingAccessEnabled)
  }, [selectedContractData?.isBOManagerBriefingMenuEnabled, userRolesData])

  const isPermittedSubmenu = (submenuAccessRoles) => {
    // Menus without a roles list are available to every user for contract type is abandoned vehicle
    if (!submenuAccessRoles?.length) {
      return (
        selectedContractData?.contractType?.toString()?.toLowerCase() ===
        utils?.contractTypes?.abandonedVehicle
      )
    }
    let permitted = false
    for (let roleIndex = 0; roleIndex < userRolesData?.length; roleIndex++) {
      if (
        submenuAccessRoles?.filter((roleName) => {
          return (
            roleName?.toString()?.toLowerCase() ===
            userRolesData[roleIndex]?.toString()?.toLowerCase()
          )
        })?.length > 0
      )
        permitted = true
    }
    return permitted
  }

  // function to check for unsaved changes and ask for confirmation, whenever hasChanges(atom handled by each page) is true
  const checkAllowNavigation = () => {
    if (hasChanges) {
      return confirmAlert({
        ...ConfirmPopupRendererObject(null, utils?.dataSaveWarnMessage),
      })
        .then(() => {
          return true
        })
        .catch(() => {
          return false
        })
    } else return true
  }
  // function to set the selected menu data in session storage (onRefresh Page / duplicate tab)
  const setSessionStoredSelectedMenu = () => {
    setLastClickedMenu(() => ({
      firstLevelMenu: selectedMenuDataValue?.firstLevelMenu || '',
      secondLevelMenu: selectedMenuDataValue?.secondLevelMenu || '',
      thirdLevelMenu: selectedMenuDataValue?.thirdLevelMenu || '',
    }))
    setOpenCollapseSubmenu(() => ({
      firstLevelMenu:
        menuItemDatasource?.[selectedMenuDataValue?.firstLevelMenu]?.groupItems
          ?.length > 0
          ? selectedMenuDataValue?.firstLevelMenu
          : '',
      secondLevelMenu:
        menuItemDatasource?.[selectedMenuDataValue?.secondLevelMenu]?.groupItems
          ?.length > 0 ||
        selectedMenuDataValue?.secondLevelMenu === 'favourites' //exception for favourites as it is not having group items untill api call completes
          ? selectedMenuDataValue?.secondLevelMenu
          : '',
      // thirdLevelMenu:
      //   menuItemDatasource?.[selectedMenuDataValue?.thirdLevelMenu]?.groupItems
      //     ?.length > 0
      //     ? selectedMenuDataValue?.thirdLevelMenu
      //     : '', //no need as still third level menu is not designes as dropdown
    }))
  }

  // iterate the menuItemDatasourceBase and set the favourites groupItems based on the list of favourites response
  const setMenuItemDatasourceBasedonFavourites = (listOfFavourites) => {
    if (listOfFavourites?.length > 0) {
      const listOfFavouritesDisplayText = listOfFavourites?.map(
        (data) => data?.reportName
      )

      let newGroupItems = new Array(listOfFavourites?.length)?.fill('')
      for (const menuKey in menuItemDatasource) {
        if (canRenderMenu(menuKey)) {
          let insertIndex = listOfFavouritesDisplayText?.indexOf(
            menuItemDatasource[menuKey]?.favouriteReportName
          )

          if (insertIndex > -1) {
            setMenuItemDatasource((prev) => {
              newGroupItems[insertIndex] = menuKey // replace the item at insertIndex with menuKey

              return {
                ...prev,
                favourites: {
                  ...prev?.favourites,
                  groupItems: [...newGroupItems],
                },
              }
            })
          }
        }
      }
    } else {
      // setting to empty array when list of favourites is empty, as the fill('') will not create newGroupItems for empty array
      setMenuItemDatasource((prev) => ({
        ...prev,
        favourites: { ...prev?.favourites, groupItems: [] },
      }))
    }
  }

  useEffect(() => {
    setSessionStoredSelectedMenu()
  }, [])

  // On page refresh: re-map mappedUserRoles to contract-specific roles
  // when selectedContractData (persisted) has a contractId and assignedContractRoles is available
  useEffect(() => {
    if (selectedContractData?.contractId && assignedContractRolesData) {
      const contractSpecificRoles = utils?.getRoleFromAssignedContractJSON(
        selectedContractData,
        assignedContractRolesData
      )
      if (contractSpecificRoles?.length > 0) {
        setMappedUserRolesData(contractSpecificRoles)
      }
    }
  }, [assignedContractRolesData, selectedContractData?.contractId])

  useEffect(() => {
    if (location?.pathname !== '/pcnpage') {
      if (selectLinkedCaseDetailsData?.length > 0) {
        setSelectLinkedCaseDetails([])
      }
      //below the useEffect if any select search case list and click the case navigate main tap and showing next and previous case prevision so the when click menu item that time will rest tha atom value
      if (selectSearchListFormGridData?.length > 0) {
        setSearchListFormGridData([])
        setSelectedcaseDetails({})
      }
    }
  }, [JSON?.stringify(selectedMenuDataValue)])

  useEffect(() => {
    if (
      reportFavouritesRefreshStatus === 'start' &&
      (selectedContractData?.contractId || widgetTypeValue?.data?.id)
    ) {
      //todo check whether menuitemDtaasource set before or not
      getListOfFavouriteReports()
    }
  }, [reportFavouritesRefreshStatus])

  // Fetch case overview data when contract changes or refresh is triggered.
  useEffect(() => {
    if (selectedContractData?.contractId) {
      fetchCaseOverviewData()
    }
  }, [selectedContractData?.contractId])
  // Refresh action should call the metadata endpoint.
  useEffect(() => {
    if (isInitialRefreshInvalidator.current) {
      isInitialRefreshInvalidator.current = false
      return
    }
    if (selectedContractData?.contractId) {
      fetchCaseOverviewData(true)
    }
  }, [refreshInvalidator])

  useEffect(() => {
    getListOfFavouriteReports()
  }, [JSON.stringify(reportConfiguredData), widgetTypeValue?.data?.id])

  const getListOfFavouriteReports = () => {
    let method, url

    if (isOrgWidget && widgetTypeValue?.data?.id) {
      method = APIEndPoints?.getOrgFavouriteReportList?.method
      url = APIEndPoints?.getOrgFavouriteReportList?.url?.replace(
        '__organisationId__',
        widgetTypeValue?.data?.id
      )
    } else if (selectedContractData?.contractId) {
      method = APIEndPoints?.getFavouriteReportList?.method
      url = APIEndPoints?.getFavouriteReportList?.url?.replace(
        '__contractId__',
        selectedContractData?.contractId
      )
    }
    getCoreData(method, url)
      .then((response) => {
        if (
          response?.status === utils?.apiResponseCode?.successCode ||
          response?.status === utils?.apiResponseCode?.noContent
        ) {
          setMenuItemDatasourceBasedonFavourites(response?.data?.data || [])
          setReportFavouriteData(response?.data?.data || [])
        } else {
          if (response.data?.exceptionMessage) {
            showToastMessage({
              message: response?.data?.exceptionMessage,
              status: utils?.toastStatus?.error,
            })
          }
        }
      })
      ?.finally(() => {
        setReportFavouritesRefreshStatus('completed')
      })
  }

  // checks the contractType, Roles, displayBasedOnFlagKey and returns true if the menu can be rendered
  const canRenderMenu = (menuKey) => {
    // Skip role check if Organisation widget is active
    if (isOrgWidget && widgetTypeValue?.data?.id) {
      return true
    }
    const displayFlagKey = menuItemDatasource[menuKey]?.displayBasedOnFlagKey

    // Special handling for Briefing menu and BO Manager role
    const isBriefingMenu = menuKey === BRIEFING_MENU_KEY
    const isBOManagerUser = userRolesData?.includes(roleName)

    // For BO Manager users accessing Briefing menu, check the BO Manager Briefing Access toggle
    if (isBriefingMenu && isBOManagerUser) {
      // If toggle is false or undefined, hide the menu for BO Manager
      if (boManagerBriefingAccessValue !== true) {
        return false
      }
      // If toggle is true, proceed with role check but bypass the isBriefingEnabled flag check
    }

    // Check in selectedContractData and reportConfiguredData
    const isReportConfigLoaded =
      reportConfiguredData &&
      !Array.isArray(reportConfiguredData) &&
      Object.keys(reportConfiguredData).length > 0

    const contractFlag =
      displayFlagKey &&
      selectedContractData?.hasOwnProperty(displayFlagKey) &&
      selectedContractData[displayFlagKey]

    const reportFlag =
      displayFlagKey &&
      reportConfiguredData?.hasOwnProperty(displayFlagKey) &&
      reportConfiguredData[displayFlagKey]

    // When reportConfiguredData is loaded and contains the flag, use it exclusively (it includes role-based checks).
    // Only fall back to contractFlag for flags not managed by reportConfiguredData.
    const isReportManagedFlag =
      isReportConfigLoaded &&
      displayFlagKey &&
      reportConfiguredData?.hasOwnProperty(displayFlagKey)

    const flagCheckResult = isReportManagedFlag
      ? reportFlag
      : contractFlag || reportFlag

    // For BO Manager users with Briefing menu, if toggle is enabled, bypass the isBriefingEnabled flag check
    // For other users, check the normal flag
    const shouldCheckFlag = !(
      isBriefingMenu &&
      isBOManagerUser &&
      boManagerBriefingAccessValue
    )

    if (
      isPermittedSubmenu(menuItemDatasource[menuKey]?.roles) &&
      (menuItemDatasource[menuKey]?.contractType?.includes(
        selectedContractData?.contractType?.toString()?.toLowerCase()
      ) ||
        !selectedContractData?.contractType) &&
      // Allow if flagCheckResult is true, or if no flagKey is set, or if BO Manager toggle is enabled
      ((displayFlagKey && flagCheckResult) ||
        !displayFlagKey ||
        !shouldCheckFlag)
    ) {
      return true
    }
    return false
  }

  const checkAndResetNavigationData = () => {
    if (selectNavigationDetails?.length > 0) {
      setSelectNavigationDetails([])
      if (
        selectedMenuDataValue?.secondLevelMenu?.toString()?.toLowerCase() ===
        'organisation'
      ) {
        navigate('/organisationlist')
      }
    }
  }

  // Fetch case overview data when contract menu is clicked
  const fetchCaseOverviewData = (useMetadataEndpoint = false) => {
    if (selectedContractData?.contractId) {
      const requestedContractId = selectedContractData?.contractId
      const caseOverviewEndpoint = useMetadataEndpoint
        ? APIEndPoints?.Contract?.caseOverView
        : APIEndPoints?.Contract?.caseOverViewMetadata
      // Reset before fetch so the previous contract's values don't bleed through while the new request is in flight.
      resetCaseOverviewData()
      getCoreData(
        caseOverviewEndpoint?.method,
        caseOverviewEndpoint?.url?.replace(
          '__contractId__',
          requestedContractId
        )
      ).then((response) => {
        // Guard against a stale response from a previously-selected contract.
        if (requestedContractId !== selectedContractData?.contractId) {
          return
        }
        if (response?.status === utils?.apiResponseCode?.successCode) {
          setCaseOverviewData(response?.data)
        } else if (response?.status === utils?.apiResponseCode?.noContent) {
          resetCaseOverviewData()
        }
      })
    } else {
      resetCaseOverviewData()
    }
  }

  const executeOnAnyMenuClick = (menuKey) => {
    if (
      [
        '/prefix',
        '/organisationlist',
        '/contractlistpage',
        '/bailiff',
      ].includes(
        menuItemDatasource[menuKey]?.redirectURL?.toString()?.toLowerCase()
      )
    ) {
      checkAndResetNavigationData()
    }
    // Fetch case overview data when clicking on contract menu item
    if (
      menuItemDatasource[menuKey]?.displayText === '__SelectedContractName__'
    ) {
      fetchCaseOverviewData()
    }
    setPoundIndex(0)
    setJobIndex(0)
    resetLastSelectedTab()
    resetCaseOverviewTabSelectedIndex()
  }

  const resetSummarizationSliderStateOnMenuNavigation = () => {
    resetMyWorkflowSummarizationDialog()
    resetOnHoldSummarizationDialog()
    resetPcnPageSummarizationDialog()
    resetCaseNumber()
  }

  // function to execute on any menu click or menuAsDropdown click
  const setOnClickMenu = (levelType, menuKey) => {
    const projectType = menuItemDatasource[menuKey]?.projectType || null
    // consider selectedMenu as current only if it from direct(firstLevelMenu,secondLevelMenu,thirdLevelMenu), else when it comes from dropwn(openColapse) no need to store it as selected for session
    if (levelType === 'firstLevelMenu') {
      setSelectedMenuData(() => ({
        firstLevelMenu: menuKey,
        secondLevelMenu: '',
        thirdLevelMenu: '',
        projectType: projectType,
      }))
      // as it is direct so, child elements can be cleared - 2nd, 3rd level
      setLastClickedMenu(() => ({
        firstLevelMenu: menuKey,
        secondLevelMenu: '',
        thirdLevelMenu: '',
      }))
      setOpenCollapseSubmenu(() => ({
        firstLevelMenu: '',
        secondLevelMenu: '',
        thirdLevelMenu: '',
      }))
    } else if (levelType === 'firstLevelMenuAsDropdown') {
      // as it is not-direct so, no need to clear prev
      setLastClickedMenu((prev) => ({
        ...prev,
        firstLevelMenu: menuKey,
      }))
      setOpenCollapseSubmenu((prev) => ({
        firstLevelMenu: prev?.firstLevelMenu === menuKey ? '' : menuKey, // open / collpase based on previous state
        secondLevelMenu: '',
        thirdLevelMenu: '',
      }))
    } else if (levelType === 'secondLevelMenu') {
      setSelectedMenuData(() => ({
        firstLevelMenu: openCollapse?.firstLevelMenu,
        secondLevelMenu: menuKey,
        thirdLevelMenu: '',
        projectType: projectType,
      }))
      // as it is direct so, child elements can be cleared - 3rd level
      setLastClickedMenu((prev) => ({
        ...prev,
        secondLevelMenu: menuKey,
        thirdLevelMenu: '',
      }))
      //   setOpenCollapseSubmenu((prev) => ({
      //     firstLevelMenu: prev?.firstLevelMenu,
      //   }))
    } else if (levelType === 'secondLevelMenuAsDropdown') {
      // as it is not-direct so, no need to clear prev
      setLastClickedMenu((prev) => ({
        ...prev,
        secondLevelMenu: menuKey,
      }))
      setOpenCollapseSubmenu((prev) => ({
        firstLevelMenu: prev?.firstLevelMenu,
        secondLevelMenu: prev?.secondLevelMenu === menuKey ? '' : menuKey, // open / collpase based on previous state
        thirdLevelMenu: '',
      }))
    } else if (levelType === 'thirdLevelMenu') {
      setSelectedMenuData((prev) => ({
        firstLevelMenu: openCollapse?.firstLevelMenu,
        secondLevelMenu: openCollapse?.secondLevelMenu,
        thirdLevelMenu: menuKey,
        projectType: projectType,
      }))
      setLastClickedMenu((prev) => ({
        ...prev,
        thirdLevelMenu: menuKey,
      }))
    }
  }
  // calls for active/highlight menu based on lastClickedMenu
  const checkForHighlight = (levelType, menuKey) => {
    if (
      levelType === 'firstLevelMenu' ||
      levelType === 'firstLevelMenuAsDropdown'
    ) {
      return lastClickedMenu?.firstLevelMenu === menuKey ? true : false
    } else if (
      levelType === 'secondLevelMenu' ||
      levelType === 'secondLevelMenuAsDropdown'
    ) {
      return lastClickedMenu?.secondLevelMenu === menuKey ? true : false
    }
  }

  const renderThirdLevelMenu = (secondLevelMenuKey, secondLevelMenuIndex) => {
    return menuItemDatasource[secondLevelMenuKey]?.groupItems?.map(
      (thirdLevelMenuKey, thirdLevelMenuIndex) => {
        let hasGroupItems =
          menuItemDatasource[thirdLevelMenuKey]?.groupItems?.length > 0
            ? true
            : false
        let thirdLevelMenuDisplayText = ''
        thirdLevelMenuDisplayText =
          menuItemDatasource[thirdLevelMenuKey]?.displayText
        if (secondLevelMenuKey === 'favourites') {
          thirdLevelMenuDisplayText =
            menuItemDatasource[thirdLevelMenuKey]?.favouriteReportName
        }

        const isActiveThirdLevelMenu =
          selectedMenuDataValue?.thirdLevelMenu?.toString()?.toLowerCase() ===
          thirdLevelMenuKey?.toString()?.toLowerCase()
        let isActiveThirdLevelMenuClassName = isActiveThirdLevelMenu
          ? 'active'
          : ''

        if (canRenderMenu(thirdLevelMenuKey)) {
          if (hasGroupItems) {
            // return renderThirdLevelMenuAsDropdown() // commented as still not yet devoloped/requirement
          } else {
            return (
              <ListItemButton
                key={thirdLevelMenuKey}
                title={thirdLevelMenuDisplayText}
                className={`subMenuitemstyle ${isActiveThirdLevelMenuClassName} subMenuIndex${thirdLevelMenuIndex}  ${
                  thirdLevelMenuKey?.toString()?.toLowerCase() === 'predebt' &&
                  !menuEnableCheck
                    ? 'disableMenuAccess'
                    : ''
                }`}
                sx={{ pl: 6, gap: 0 }}
                onClick={async () => {
                  const allow = await checkAllowNavigation()
                  if (allow) {
                    executeOnAnyMenuClick(thirdLevelMenuKey)
                    setOnClickMenu('thirdLevelMenu', thirdLevelMenuKey)
                    const redirectURL =
                      menuItemDatasource[thirdLevelMenuKey]?.redirectURL
                    resetSummarizationSliderStateOnMenuNavigation()
                    navigate(redirectURL)
                  }
                }}
              >
                <ListItemText
                  className={'subMenuitemstext'}
                  primary={
                    <div className="thirdLevelMenu">
                      <div
                        className={`circleHighlihtThirdLevelMenu ${
                          isActiveThirdLevelMenu ? '' : 'hide'
                        }`}
                      ></div>
                      <p
                        className="menuDisplayText"
                        title={thirdLevelMenuDisplayText}
                      >
                        {thirdLevelMenuDisplayText}
                      </p>
                    </div>
                  }
                />
              </ListItemButton>
            )
          }
        } else {
          return null
        }
      }
    )
  }
  const renderSecondLevelMenuAsDropdown = (
    secondLevelMenuKey,
    secondLevelMenuIndex
  ) => {
    const secondLevelMenuDisplayText =
      menuItemDatasource[secondLevelMenuKey]?.displayText

    let isActiveSecondLevelMenu =
      selectedMenuDataValue?.toString()?.toLowerCase() ===
      secondLevelMenuKey?.toString()?.toLowerCase()
        ? true
        : false
    let isActiveSecondLevelMenuClassName = isActiveSecondLevelMenu
      ? 'active'
      : ''

    let openedSecondLevelMenu =
      openCollapse?.secondLevelMenu === secondLevelMenuKey

    let openedSecondLevelMenuClassName = openedSecondLevelMenu
      ? 'Menugroupradius opened'
      : ''

    return (
      <div
        className={`levelTwo outeranchorgroup ${isActiveSecondLevelMenuClassName} ${openedSecondLevelMenuClassName}`}
      >
        <ListItem
          key={secondLevelMenuIndex}
          title={secondLevelMenuDisplayText}
          onClick={() => {
            executeOnAnyMenuClick(secondLevelMenuKey)
            setMenuBarExpanded(() => true)
            setOnClickMenu('secondLevelMenuAsDropdown', secondLevelMenuKey)
          }}
          className={`item-height drawer__mainmenu_item ${isActiveSecondLevelMenuClassName} ${openedSecondLevelMenuClassName} subMenuIndex${secondLevelMenuIndex}`}
        >
          {menuItemDatasource[secondLevelMenuKey]?.imageURLactive ||
          menuItemDatasource[secondLevelMenuKey]?.imageURLinactive ? (
            <ListItemIcon
              className={openedSecondLevelMenu ? 'activemenu' : 'inactivemenu'}
            >
              <img
                className="img-logo"
                src={
                  openedSecondLevelMenu
                    ? menuItemDatasource[secondLevelMenuKey]?.imageURLactive
                    : menuItemDatasource[secondLevelMenuKey]?.imageURLinactive
                }
              />
            </ListItemIcon>
          ) : null}
          <ListItemText
            className={`Menuitemstyle ${
              openedSecondLevelMenu ? 'activemenu' : 'inactivemenu'
            }`}
            primary={secondLevelMenuDisplayText}
          />
          {openedSecondLevelMenu ? (
            <ExpandLess className="expandlessIcon" />
          ) : (
            <ExpandMore className="expandmoreIcon" />
          )}
        </ListItem>
        <Collapse
          className={'MenuItemgroup'}
          in={openedSecondLevelMenu}
          timeout="auto"
          cls
          unmountOnExit
        >
          <List className={'subitem'} component="div">
            {renderThirdLevelMenu(secondLevelMenuKey, secondLevelMenuIndex)}
          </List>
        </Collapse>
      </div>
    )
  }

  const renderSecondLevelMenu = (secondLevelMenuKey, secondLevelMenuIndex) => {
    return menuItemDatasource[secondLevelMenuKey]?.groupItems?.map(
      (secondLevelMenuKey, secondLevelMenuIndex) => {
        let hasGroupItems =
          menuItemDatasource[secondLevelMenuKey]?.groupItems?.length > 0
            ? true
            : false
        const secondLevelMenuDisplayText =
          menuItemDatasource[secondLevelMenuKey]?.displayText

        let highlightMenuClassName = checkForHighlight(
          'secondLevelMenu',
          secondLevelMenuKey
        )
          ? 'active'
          : ''

        if (canRenderMenu(secondLevelMenuKey)) {
          if (hasGroupItems || secondLevelMenuKey === 'favourites') {
            // For favourites: only show when it has items loaded from API
            if (secondLevelMenuKey === 'favourites' && !hasGroupItems) {
              return null
            }
            // Hide second-level dropdown if none of its children are renderable
            if (
              hasGroupItems &&
              !menuItemDatasource[secondLevelMenuKey]?.groupItems?.some(
                (childKey) => canRenderMenu(childKey)
              )
            ) {
              return null
            }
            return renderSecondLevelMenuAsDropdown(
              secondLevelMenuKey,
              secondLevelMenuIndex
            )
          } else {
            return (
              <ListItemButton
                title={secondLevelMenuDisplayText}
                key={secondLevelMenuKey}
                className={`subMenuitemstyle ${highlightMenuClassName} subMenuIndex${secondLevelMenuIndex} ${
                  secondLevelMenuKey?.toString()?.toLowerCase() === 'predebt' &&
                  !menuEnableCheck
                    ? 'disableMenu'
                    : ''
                }`}
                sx={{ pl: 6, gap: 0 }}
                onClick={async () => {
                  const allow = await checkAllowNavigation()
                  if (allow) {
                    setOnClickMenu('secondLevelMenu', secondLevelMenuKey)
                    executeOnAnyMenuClick(secondLevelMenuKey)
                    const redirectURL =
                      menuItemDatasource[secondLevelMenuKey]?.redirectURL
                    resetSummarizationSliderStateOnMenuNavigation()
                    navigate(redirectURL)
                  }
                }}
              >
                <ListItemText
                  className={'subMenuitemstext'}
                  primary={`${secondLevelMenuDisplayText}`}
                />
              </ListItemButton>
            )
          }
        } else {
          return null
        }
      }
    )
  }

  const renderFirstLevelMenuAsDropdown = (
    firstLevelMenuKey,
    firstLevelMenuIndex
  ) => {
    const firstLevelMenuDisplayText =
      menuItemDatasource[firstLevelMenuKey]?.displayText

    let highlightMenu = checkForHighlight(
      'firstLevelMenuAsDropdown',
      firstLevelMenuKey
    )

    let openedFirstLevelMenu =
      openCollapse?.firstLevelMenu === firstLevelMenuKey
    let openedFirstLevelMenuClassName = openedFirstLevelMenu
      ? 'Menugroupradius opened'
      : ''

    let renderedSubMenuIndex = -1

    return (
      <div
        className={`levelOne outeranchorgroup ${
          highlightMenu ? 'active' : ''
        } ${openedFirstLevelMenuClassName}`}
      >
        <ListItem
          title={firstLevelMenuDisplayText}
          key={firstLevelMenuIndex}
          onClick={() => {
            executeOnAnyMenuClick(firstLevelMenuKey)
            setMenuBarExpanded(() => true)
            setOnClickMenu('firstLevelMenuAsDropdown', firstLevelMenuKey)
          }}
          className={`item-height drawer__mainmenu_item ${
            isOrgWidget && firstLevelMenuDisplayText === 'Reporting'
              ? 'orgReport'
              : ''
          } ${highlightMenu ? 'active' : ''}${openedFirstLevelMenuClassName}`}
        >
          {menuItemDatasource[firstLevelMenuKey]?.imageURLactive ||
          menuItemDatasource[firstLevelMenuKey]?.imageURLinactive ? (
            <ListItemIcon
              className={openedFirstLevelMenu ? 'activemenu' : 'inactivemenu'}
            >
              <img
                className="img-logo"
                src={
                  highlightMenu
                    ? menuItemDatasource[firstLevelMenuKey]?.imageURLactive
                    : menuItemDatasource[firstLevelMenuKey]?.imageURLinactive
                }
              />
            </ListItemIcon>
          ) : null}
          <ListItemText
            className={`Menuitemstyle ${
              openedFirstLevelMenu ? 'activemenu' : 'inactivemenu'
            }`}
            primary={
              isOrgWidget &&
              widgetTypeValue?.data?.id &&
              firstLevelMenuDisplayText === 'Reporting'
                ? 'Organization Reports'
                : firstLevelMenuDisplayText
            }
          />
          {openedFirstLevelMenu ? (
            <ExpandLess className="expandlessIcon" />
          ) : (
            <ExpandMore className="expandmoreIcon" />
          )}
        </ListItem>
        <Collapse
          className={'MenuItemgroup'}
          in={openedFirstLevelMenu}
          timeout="auto"
          cls
          unmountOnExit
        >
          <List className={'subitem'} component="div">
            {renderSecondLevelMenu(firstLevelMenuKey, firstLevelMenuIndex)}
          </List>
        </Collapse>
      </div>
    )
  }

  const renderFirstLevelMenu = (firstLevelMenuKey, firstLevelMenuIndex) => {
    const firstLevelMenuDisplayText =
      menuItemDatasource[firstLevelMenuKey]?.displayText

    let highlightMenu = checkForHighlight('firstLevelMenu', firstLevelMenuKey)

    let hasGroupItems =
      menuItemDatasource[firstLevelMenuKey]?.groupItems?.length > 0
        ? true
        : false

    if (canRenderMenu(firstLevelMenuKey)) {
      if (hasGroupItems) {
        // Hide parent menu if none of its submenu items are renderable for the current user
        const hasAnyVisibleChild = menuItemDatasource[
          firstLevelMenuKey
        ]?.groupItems?.some((childKey) => canRenderMenu(childKey))
        if (!hasAnyVisibleChild) {
          return null
        }
        return renderFirstLevelMenuAsDropdown(
          firstLevelMenuKey,
          firstLevelMenuIndex
        )
      } else {
        return (
          <div
            className={`outeranchor ${highlightMenu ? 'active' : ''}`}
            id={firstLevelMenuIndex}
          >
            <ListItem
              title={firstLevelMenuDisplayText}
              dataTestId={firstLevelMenuKey}
              key={firstLevelMenuIndex}
              component={Link}
              onClick={async () => {
                executeOnAnyMenuClick(firstLevelMenuKey)
                const allow = await checkAllowNavigation()
                if (allow) {
                  setOnClickMenu('firstLevelMenu', firstLevelMenuKey)
                  setMenuBarExpanded(true)
                  const redirectURL =
                    menuItemDatasource[firstLevelMenuKey]?.displayText ===
                    '__SelectedContractName__'
                      ? utils?.getContractLandingPath(
                          selectedContractData?.contractType
                        )
                      : menuItemDatasource[firstLevelMenuKey]?.redirectURL
                  resetSummarizationSliderStateOnMenuNavigation()
                  navigate(redirectURL)
                }
              }}
              className={`item-height drawer__mainmenu_item ${
                highlightMenu ? 'active' : ''
              }${
                isOrgWidget &&
                firstLevelMenuDisplayText === '__SelectedOrgName__'
                  ? 'disableMenuAccess'
                  : ''
              }`}
            >
              <ListItemIcon
                className={highlightMenu ? 'activemenu' : 'inactivemenu'}
              >
                <img
                  className="img-logo"
                  src={
                    highlightMenu
                      ? menuItemDatasource[firstLevelMenuKey]?.imageURLactive
                      : menuItemDatasource[firstLevelMenuKey]?.imageURLinactive
                  }
                />
              </ListItemIcon>
              <ListItemText
                className={`Menuitemstyle ${
                  highlightMenu ? 'activemenu' : 'inactivemenu'
                }`}
                primary={
                  firstLevelMenuDisplayText === '__SelectedContractName__'
                    ? selectedContractData?.contractName
                    : firstLevelMenuDisplayText === '__SelectedOrgName__'
                    ? widgetTypeValue?.data?.name
                    : firstLevelMenuDisplayText
                }
              />
            </ListItem>
          </div>
        )
      }
    } else {
      return null
    }
  }

  function onPopupWindowChangeChandler() {
    setSupportMenuSelected(() => false)
  }
  function getReportConfiguration({ contractId, orgId }) {
    let method
    let url

    if (orgId) {
      method = APIEndPoints?.reportConfiguration?.getOrgReportDetails?.method
      url =
        APIEndPoints?.reportConfiguration?.getOrgReportDetails?.url?.replace(
          '__organisationId__',
          orgId
        )
    } else if (contractId) {
      method = APIEndPoints?.reportConfiguration?.getReportDetails?.method
      url = APIEndPoints?.reportConfiguration?.getReportDetails?.url?.replace(
        '_ContractId_',
        contractId
      )
    } else {
      // No valid ID provided
      showToastMessage({
        message: 'No valid contract or organisation ID provided.',
        status: utils?.toastStatus?.error,
      })
      return
    }

    getCoreData(method, url)
      .then((response) => {
        if (response?.status === utils?.apiResponseCode?.successCode) {
          // Normalize response to handle both old array format and new object format
          let reportList = []
          if (Array.isArray(response?.data)) {
            reportList = response.data
          } else if (
            response?.data?.reportList ||
            response?.data?.subReportRequests ||
            response?.data?.reportRoles
          ) {
            // New format: extract reportList
            reportList = response?.data?.reportList || []
          }
          setReportDetails(reportList)
        } else {
          showToastMessage({
            message: response?.data?.validationErrors?.[0]?.errorMessage,
            status: utils?.toastStatus?.error,
          })
        }
      })
      .catch((error) => {
        showToastMessage({
          message: error,
          status: utils?.toastStatus?.error,
        })
      })
  }
  useEffect(() => {
    if (widgetTypeValue?.data?.id) {
      getReportConfiguration({ orgId: widgetTypeValue.data.id })
    } else if (selectedContractData?.contractId > 0) {
      getReportConfiguration({ contractId: selectedContractData.contractId })
    }
  }, [selectedContractData?.contractId, widgetTypeValue?.data?.id])

  useEffect(() => {
    reportHideAndShowConfiguration(reportDetails)
  }, [reportDetails])

  // Here in this function, we are setting the report configuration data based on the reportDetails received from the API.

  function reportHideAndShowConfiguration(reportDetails) {
    let reportMenuConfigurationContainer = {}
    const currentUserRoles = (userRolesData || [])?.map((role) =>
      role?.toString()?.toLowerCase()
    )
    const isSuperOrSimpleAdmin = currentUserRoles?.some((roleName) =>
      ['superadmin', 'simpleadmin']?.includes(roleName)
    )

    let isEveryReportsVisible =
      reportDetails?.length &&
      reportDetails?.some((reportMenu) => reportMenu?.isMenuEnabled)
    isEveryReportsVisible
      ? (reportMenuConfigurationContainer.isEveryReportsEnabled = true)
      : (reportMenuConfigurationContainer.isEveryReportsEnabled = false)
    reportDetails?.length &&
      reportDetails?.forEach((reportMenu) => {
        // Find the flagKey for the parent reportMenu
        const parentFlagObj = utils?.reportFlagKeys?.find(
          (reportFlagKeysItem) =>
            reportFlagKeysItem?.reportName === reportMenu?.reportMenu
        )
        const parentKey = parentFlagObj
          ? parentFlagObj?.flagKey
          : (() => {
              let parentFlagKey = reportMenu?.reportMenu?.replace(
                /[\s\.'"]/g,
                ''
              )
              return (
                parentFlagKey?.charAt(0)?.toLowerCase() +
                parentFlagKey?.slice(1)
              )
            })()

        // Track if any submenu is enabled
        let anySubMenuEnabled = false

        reportMenu?.subMenu?.forEach((subMenuDetail) => {
          // Find the flagKey for the subMenu
          const flagObj = utils?.reportFlagKeys?.find(
            (reportFlagKeysItem) =>
              reportFlagKeysItem?.reportName === subMenuDetail?.reportName
          )
          const key = flagObj
            ? flagObj?.flagKey
            : (() => {
                let subMenuKey = subMenuDetail?.reportName.replace(
                  /[\s\.'"]/g,
                  ''
                )
                return (
                  subMenuKey?.charAt(0)?.toLowerCase() + subMenuKey?.slice(1)
                )
              })()

          const isSubReportEnabled = !!subMenuDetail?.isSubReportEnabled
          const reportRoles = Array.isArray(subMenuDetail?.roles)
            ? subMenuDetail?.roles
            : []
          const hasReportRoles = reportRoles?.length > 0
          const isRoleMatched = reportRoles?.some((role) =>
            currentUserRoles?.includes(
              role?.roleName?.toString()?.toLowerCase()
            )
          )

          // Rules:
          // 1) Super/Simple admin: skip role checks.
          // 2) Non-admin users: if roles are present, show only on role match.
          // 3) Non-admin users: if roles are null/empty and enabled, show report.
          const shouldDisplaySubReport =
            isSubReportEnabled &&
            (isSuperOrSimpleAdmin || !hasReportRoles || isRoleMatched)

          reportMenuConfigurationContainer[key] = shouldDisplaySubReport

          if (shouldDisplaySubReport) {
            anySubMenuEnabled = true
          }
        })

        // Set parent key:
        // - Super/Simple admin: always visible.
        // - Non-admin with submenu items: visible only when at least one child report is visible.
        // - Non-admin without submenu items: fall back to parent toggle.
        reportMenuConfigurationContainer[parentKey] = isSuperOrSimpleAdmin
          ? true
          : reportMenu?.subMenu?.length > 0
          ? anySubMenuEnabled
          : !!reportMenu?.isMenuEnabled
      })

    // Re-evaluate isEveryReportsEnabled based on actual visibility after role checks.
    // For non-admin users, only enable Reporting if at least one report category is visible.
    if (!isSuperOrSimpleAdmin) {
      const hasAnyVisibleReport = Object.keys(
        reportMenuConfigurationContainer
      ).some(
        (key) =>
          key !== 'isEveryReportsEnabled' &&
          reportMenuConfigurationContainer[key] === true
      )
      reportMenuConfigurationContainer.isEveryReportsEnabled =
        hasAnyVisibleReport
    }

    setReportConfiguredData(reportMenuConfigurationContainer)
  }

  const renderHaloMenu = () => {
    return isMenuBarExpanded ? (
      <div className="staticMenus">
        <div className="outeranchor" id="supportTicket">
          <ListItem
            title="Support Request"
            dataTestId="supportTicket"
            key="supportTicket"
            onClick={() => {
              executeOnAnyMenuClick()
              setSupportMenuSelected(() => true)
            }}
            className={`item-height drawer__mainmenu_item`}
          >
            <ListItemIcon className={'activemenu'}>
              <img
                className="img-logo"
                src={
                  supportMenuSelected
                    ? SupportMenuIconActive
                    : SupportMenuIconInActive
                }
              />
            </ListItemIcon>
            <ListItemText
              className={`Menuitemstyle ${
                supportMenuSelected ? 'activemenu' : 'inactivemenu'
              }`}
              primary="Support Request"
            />
          </ListItem>
        </div>
      </div>
    ) : (
      <div className="staticMenusIcon">
        <div className="outeranchor" id="supportTicket">
          <ListItem
            title="Support Request"
            dataTestId="supportTicket"
            key="supportTicket"
            onClick={() => {
              executeOnAnyMenuClick()
              setSupportMenuSelected(() => true)
            }}
            className={`item-height drawer__mainmenu_item`}
          >
            <ListItemIcon className={'activemenu'}>
              <img
                className="img-logo"
                src={
                  supportMenuSelected
                    ? SupportMenuIconActive
                    : SupportMenuIconInActive
                }
              />
            </ListItemIcon>
          </ListItem>
        </div>
      </div>
    )
  }

  const renderMenuLayout = () => {
    const renderingMenuOrderItems = selectedContractData?.contractId
      ? utils?.contractDependentMenuItemList
      : isOrgWidget && widgetTypeValue?.data?.id
      ? utils?.orgMenuItemList
      : utils?.contractIndependentMenuItemList

    return (
      <div className={`drawer drawer_${isMenuBarExpanded ? 'open' : 'close'}`}>
        <MUIDrawer
          variant="permanent"
          className={`muidrawer_${isMenuBarExpanded ? 'open' : 'close'} ${
            selectedMenuDataValue?.projectType?.toString()?.toLowerCase() ===
              utils?.airaNames?.airaName?.toString()?.toLowerCase() ||
            isAiraLayoutChanges
              ? utils?.airaNames?.nonNPS?.toString()?.toLowerCase()
              : ''
          }`}
          id="MUIDrawer_Menu"
        >
          <div className="drawer_  v-scroll-auto">
            <List disablePadding className="drawer__mainmenu menu">
              <div className="StaticItem">
                <div className="StaticItemInner" key="divfirstmenu0">
                  <ListItem
                    key="firstmenu0"
                    component={Link}
                    className="item-height drawer__mainmenu_item firstmenu"
                  >
                    <ListItemText className="navsectionMain" primary="" />
                  </ListItem>
                  <div className="expandableIcon">
                    {!isMenuBarExpanded ? (
                      <KeyboardDoubleArrowRightIcon
                        className="expandMoreIcon"
                        onClick={() => {
                          setMenuBarExpanded(() => true)
                        }}
                      />
                    ) : (
                      <KeyboardDoubleArrowLeftIcon
                        className="expandLessIcon"
                        onClick={() => {
                          setMenuBarExpanded(() => false)
                        }}
                      />
                    )}
                  </div>
                  {renderingMenuOrderItems?.map(
                    (firstLevelMenuKey, firstLevelMenuIndex) => {
                      return renderFirstLevelMenu(
                        firstLevelMenuKey,
                        firstLevelMenuIndex
                      )
                    }
                  )}
                </div>
              </div>
            </List>
          </div>
        </MUIDrawer>
        {selectedContractData?.isHaloIntegration === true
          ? renderHaloMenu()
          : null}
        {supportMenuSelected && (
          <HaloSupportTicket onChangedPopup={onPopupWindowChangeChandler} />
        )}
      </div>
    )
  }

  return <>{renderMenuLayout()}</>
}

export default MenuLayout
